import React from 'react';
import { CheckIcon } from 'lucide-react';
import { images, partnerPromises, propertyPartners, propertyServices } from '../data/site';
import { SectionHeading } from './SectionHeading';
export function PropertyProfessionals() {
  return <section className="w-full bg-gray-50" data-id="element-88" data-mp="v1l8d2ts82ak">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:py-24" data-id="element-89" data-mp="z2wzxdw7uxle">
        <div className="grid items-center gap-14 lg:grid-cols-2" data-id="element-90" data-mp="z1c3fiqcd4kw">
          <div data-id="element-91" data-mp="l2w081rotw7i">
            <SectionHeading eyebrow="Our Specialist Area" title="Property Professionals" align="left" description="We understand the demands of the property industry. That's why landlords, estate agents, letting agencies and property managers across Guernsey trust us to deliver consistent, high-quality service they can depend on." data-id="element-92" data-mp="l2cgcfih8xqu" />

            <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-93" data-mp="26hrxf7gdq9r7">
              {propertyServices.map(service => <li key={service} className="flex items-center gap-3 text-[15px] text-gray-700" data-id="element-94" data-mp="2ag98u36u26ef">
                  <CheckIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-95" data-mp="3t5qcjvruwq1d" />
                  {service}
                </li>)}
            </ul>

            <div className="mt-10" data-id="element-96" data-mp="6rytd8skh6kn">
              <p className="font-display text-[12px] font-bold uppercase tracking-[0.28em] text-gray-500" data-id="element-97" data-mp="3f6qmqksly53m">
                We Work With
              </p>
              <ul className="mt-4 flex flex-wrap gap-3" data-id="element-98" data-mp="3a9gqomapqv6t">
                {propertyPartners.map(partner => <li key={partner} className="border border-gray-300 bg-white px-4 py-2 font-display text-[12px] font-bold uppercase tracking-wider text-navy" data-id="element-99" data-mp="3p6hfoi1isc1l">
                    {partner}
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="flex flex-col gap-6" data-id="element-100" data-mp="16jkcrg60w4lc">
            <img src={images.property} alt="Professional cleaner preparing a rental apartment kitchen for a new tenant" className="h-72 w-full object-cover lg:h-96" data-id="element-101" data-mp="16isu15xiy1ch" />
            <div className="bg-navy p-8" data-id="element-102" data-mp="1gfe0lvp6zkif">
              <p className="font-display text-[12px] font-bold uppercase tracking-[0.28em] text-gold" data-id="element-103" data-mp="1lgl43ikaxxja">
                Get in Touch
              </p>
              <h3 className="mt-3 font-display text-xl font-extrabold uppercase tracking-wide text-white" data-id="element-104" data-mp="nqgk9y4jjxsb">
                A Trusted Partner for Property Professionals
              </h3>
              <ul className="mt-5 flex flex-wrap gap-x-5 gap-y-2 text-[14px] text-white/75" data-id="element-105" data-mp="xpfsjfle9res">
                {partnerPromises.map(promise => <li key={promise} className="flex items-center gap-2" data-id="element-106" data-mp="52lasqfyp650">
                    <span className="h-1.5 w-1.5 rounded-full bg-gold" aria-hidden="true" data-id="element-107" data-mp="a16b0pv7rptg" />
                    {promise}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}